import { PackageVersionModule } from '@/pages/report/package/versions/types'
import DocumentPreview from '@/pages/report/package/versions/v1/document/DocumentPreview.vue'
import {
  formatPackageDataRequest,
  formatPackageDataResponse,
} from '@/pages/report/package/versions/v1/formatPackageData'
import { buildManualPackageData } from '@/pages/report/package/versions/v1/manualPackageData'

const packageVersionV1: PackageVersionModule = {
  DocumentPreview,
  formatPackageDataRequest,
  formatPackageDataResponse,
  buildManualPackageData,
}

export default packageVersionV1
